import { Middleware, createSlice } from "@reduxjs/toolkit"
import api from "../../api/services"
import { Apply3Response } from "../../api/types/apply3"

type initialState = {
    response: Apply3Response | null
}

const productInfoSlice = createSlice({
    name: "productInfo",
    initialState: { response: null } as initialState,
    reducers: {
        setProductInfo: (state, action) => {
            state.response = action.payload
        }
    }
})
export const { setProductInfo } = productInfoSlice.actions
export default productInfoSlice.reducer

export const productInfoHandlerMiddleware: Middleware = () => next => action => {
    return next(action)
}



